<template>
<div v-wechat-title="title">
    <crud-facecade ref="config-list" :url="url" :columns="columnList" :buttons="buttons"  dialogWidth="60%"
                 :addButton="{permission:'default'}" :deleteButton="{enabled:true,permission:'default'}"
                 :updateButton="{permission:'default'}" @loadingSaveAsView="loadSaveAsView"
                 >
  </crud-facecade>
   <form-dialog ref="form-saveas" title="另存为模板" :data="saveas.data"  width="60%"    class="form-table-h360"
                 :visible.sync="saveas.dialogVisible" :columns="saveAsColumnList"
                 @confirm="SaveAsConfirm"></form-dialog>
</div>

</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `CountingConfig`,
    // name:'Inventory2',
    props: {

    },
    data() {
        return {
            title: `基础数据-清点流程配置`,
            allConfig: [],
            url: { baseURL: `/api/AcisSystem/CountingConfig`,
                get: (query) => {
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/AcisSystem/CountingConfig/Get`)
                        req.then(data => {
                            this.allConfig = data || []
                            resolve(this.allConfig)
                        }).catch(e => reject(e))
                    })
                },
                getOne: (row) => {
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/AcisSystem/CountingConfig/Get/${row.id}`)
                        req.then(data => {
                            data.details = _.map(_.orderBy(data.details, `display_order`), d => {
                                d.calculate_relation = _.map(d.calculate_relation && d.calculate_relation.split(`,`), d => d * 1)
                                return d
                            })
                            resolve(data)
                        })
                    })
                },
                put: (row) => {
                    let data = _.cloneDeep(row)
                    data.details = _.map(_.filter(data.details, d => d.dic_event_id > 0), (d, index) => {
                        d.calculate_relation = d.calculate_relation && d.calculate_relation.toString()
                        d.display_order = index + 1
                        return d
                    }) || [-1]
                    return this.myaxios.put(`/api/AcisSystem/CountingConfig/Put`, data)
                },
                post: (row) => {
                    let data = _.cloneDeep(row)
                    data.details = _.map(_.filter(data.details, d => d.dic_event_id > 0), (d, index) => {
                        d.display_order = index + 1
                        d.calculate_relation = d.calculate_relation && d.calculate_relation.toString()
                        return d
                    })
                    return this.myaxios.post(`/api/AcisSystem/CountingConfig/Post`, data)
                } },
            // buttons:[],
            buttons: [{
                label: `另存为`,
                type: `primary`,
                emit: `loadingSaveAsView`,
                permission: `default`
            }],
            countingEventNode: [],
            saveas: {
                dialogVisible: false,
                data: {}
            }
        }
    },
    computed: {
        ...mapGetters([`operation_ward_auth`, `sys_enums`, `screenHeight`]),
        detailColumns() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`
            }, {
                type: `select`,
                prop: `dic_event_id`,
                label: `节点`,
                width: `200`,
                isListable: true,
                readonly: false,
                options: this.countingEventNode,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `bool`,
                prop: `allow_edit`,
                label: `允许编辑`,
                width: `100`,
                isListable: true,
                readonly: false,
                options: `enum_bool`,
                default: false
            }, {
                type: `bool`,
                prop: `need_check`,
                label: `核对`,
                width: `100`,
                isListable: true,
                readonly: false,
                options: `enum_bool`,
                default: false
            }, {
                type: `multiselect`,
                prop: `calculate_relation`,
                label: `计算关联项目`,
                options: this.countingEventNode,
                isListable: true,
                readonly: false,
                config: {
                    collapseTags: false
                }
            }]
        },
        columnList() {
            let me = this
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `string`,
                prop: `workflow_name`,
                label: `名称`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                colspan: 6
            }, {
                type: `select`,
                prop: `enum_count_type`,
                label: `清点类型`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                options: this.sys_enums.CountType,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                colspan: 6,
                readonly: (that, { area, row }) => {
                    if (area == `form`) {
                        return row.origion.id > 0
                    }
                    return true
                }
            }, {
                type: `select`,
                prop: `dic_operating_ward_ids`,
                label: `所属区域`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                options: this.operation_ward_auth,
                colspan: 8
            }, {
                type: `string`,
                prop: `doc_id`,
                label: `文书ID`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                colspan: 4
            }, {
                type: `bool`,
                prop: `is_default`,
                label: `是否默认`,
                width: `200`,
                isListable: true,
                isExpand: false,
                searchable: true,
                sortable: false,
                readonly: false,
                options: `is_default`,
                default: false,
                colspan: 4,
                // meta:{allConfig:this.allConfig},
                change: (that, { row, column }) => {
                    if (row.is_default) {
                        let data = [{
                            id: row.id,
                            is_default: true
                        }]

                        _.forEach(_.filter(me.allConfig, d => d.enum_count_type == row.enum_count_type && d.is_default && d.id != row.id &&
                            (d.dic_operating_ward_ids == row.dic_operating_ward_ids || !d.dic_operating_ward_ids || !row.dic_operating_ward_ids)
                        ), old => {
                            data.push({ id: old.id, is_default: false })
                        })
                        let req = this.myaxios.put(`/api/AcisSystem/CountingConfig/PutMany`, data)
                        req.then(() => {
                            this.$message.success(`设置成功`)
                            this.$refs[`config-list`] && this.$refs[`config-list`].ReloadListData(true)
                        })
                    }
                }
            }, {
                type: `table`,
                prop: `details`,
                label: `详情`,
                isListable: false,
                isEditable: true,
                isCreatable: true,
                options: this.detailColumns,
                colspan: 24,
                config: {
                    height: this.screenHeight - 300
                }
            }]
        },
        saveAsColumnList() {
            return _.filter(this.columnList, d => d.isEditable)
        }
    },
    mounted() {
        this.loadCountingEventNode()
    },
    methods: {
        loadCountingEventNode() {
            let req = this.myaxios.get(`/api/AcisSystem/Event/GetCountingNodeEvent`)
            req.then(data => {
                this.countingEventNode = data
            })
        },
        loadSaveAsView({ row }) {
            let req = this.myaxios.get(`/api/AcisSystem/CountingConfig/Get/${row.id}`)
            req.then(data => {
                data.id = undefined
                data.workflow_name = ``
                data.details = _.map(data.details, d => {
                    d.calculate_relation = _.map(d.calculate_relation && d.calculate_relation.split(`,`), d => d * 1)
                    return d
                })
                this.saveas.data = data
                this.saveas.dialogVisible = true
            }).catch(e => console.log(e))
        },
        SaveAsConfirm(row) {
            let data = { ...row }
            data.dic_operating_ward_ids = data.dic_operating_ward_id
            data.details = _.map(_.filter(data.details, d => d.dic_event_id > 0), (d, index) => {
                d.display_order = index + 1
                d.calculate_relation = d.calculate_relation && d.calculate_relation.toString()
                return d
            })
            let req = this.myaxios.post(`/api/AcisSystem/CountingConfig/Post`, data)
            req.then(() => {
                this.$message.success(`保存成功`)
                this.saveas.dialogVisible = false
                this.$refs[`config-list`].ReloadListData()
            })
        }
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Counting/CountingConfig.vue